<div class="d-flex justify-content-center align-items-center">
  <app-full-page-spinner *ngIf="loading$ | async"></app-full-page-spinner>
  <div class="card shadow-sm card-container">
    <div class="card-body text-center p-4 p-md-5">
      <h1 class="h3 text-dark mb-3" i18n>Thank you for your order!</h1>
      <p class="text-muted small mb-4 lh-base" i18n>
        Your order has been confirmed and you will receive an order confirmation via
        {{ successMessage$ | async }} shortly
      </p>

      <div class="border-top pt-4">
        <h2 class="h5 text-dark mb-3" i18n>
          Create an Account to View and Track All Your Orders
        </h2>

        <div class="container" *ngIf="personalInfo$ | async">
          <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="row">
              <div class="col-12 mb-3">
                <app-password-input
                  [identifier]="RegisterFormKey.password"
                  [formControlName]="RegisterFormKey.password"
                  [formErrorMessages]="ErrorMessages"
                  label="Password"
                  i18n-label
                  placeholder="Password"
                  i18n-placeholder
                ></app-password-input>
              </div>
              <div class="col-12 mb-3">
                <app-password-input
                  [identifier]="RegisterFormKey.passwordConfirm"
                  [formControlName]="RegisterFormKey.passwordConfirm"
                  [groupValidationErrorType]="PasswordMatchErrorType"
                  [invalidGroupErrorMessage]="PasswordMatchErrorMessage"
                  [formErrorMessages]="ErrorMessages"
                  label="Re-enter Password"
                  i18n-label
                  placeholder="Re-enter Password"
                  i18n-placeholder
                ></app-password-input>
              </div>
              <div class="col-12 my-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [formControlName]="RegisterFormKey.newsletters"
                    id="newsletters"
                  />
                  <label i18n class="form-check-label" for="newsletters">
                    Subscribe to the Princess House Newsletter
                  </label>
                </div>
              </div>
              <div class="col-12 my-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [formControlName]="RegisterFormKey.shareWithConsultant"
                    id="shareWithConsultant"
                  />
                  <label i18n class="form-check-label" for="shareWithConsultant">
                    Share my contact information with my Consultant
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-primary w-100" [disabled]="disabled" i18n>
                  Create Account
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
